import { fmtEUR, calcTotals, fmtDate } from "../lib/storage";

export default function InvoicePreview({ budget }) {
  const t = calcTotals(budget.partidas);
  const c = budget.cliente || {};
  return (
    <div className="rx-card p-8" data-testid="invoice-preview">
      <div className="flex items-start justify-between mb-8">
        <div>
          <h2 className="font-display font-bold text-2xl text-slate-900">Vista Previa</h2>
          <div className="text-slate-500 text-sm">Reformas Express</div>
        </div>
        <div className="w-12 h-12 rounded-md border border-slate-200 flex items-center justify-center text-blue-600 font-bold font-display text-lg">
          R
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6 mb-6">
        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-2">Cliente</div>
          <div className="text-sm space-y-0.5">
            <div className="font-semibold text-slate-900">{c.nombre || "—"}</div>
            {c.nif && <div className="text-slate-600">NIF/CIF: {c.nif}</div>}
            {c.direccion && <div className="text-slate-600">{c.direccion}</div>}
            {c.telefono && <div className="text-slate-600">Tel: {c.telefono}</div>}
            {c.email && <div className="text-slate-600">{c.email}</div>}
          </div>
        </div>
        <div className="text-right">
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-2">Fecha</div>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-50 border border-slate-200 rounded-md text-sm" data-testid="invoice-date">
            {fmtDate(budget.fecha)}
          </div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mt-4 mb-1">Nº</div>
          <div className="font-mono text-sm">{budget.id}</div>
        </div>
      </div>

      <div className="border-t border-slate-200 pt-4">
        <h3 className="font-display font-bold mb-3">Partidas ({(budget.partidas || []).length})</h3>
        <div className="divide-y divide-slate-100">
          {(budget.partidas || []).map((p, i) => {
            const subtotal = (Number(p.cantidad) || 0) * (Number(p.precio_unitario) || 0);
            return (
              <div key={p.id} className="py-2.5 flex items-start gap-4 text-sm">
                <div className="text-slate-400 font-mono pt-0.5 w-7">{i + 1}.</div>
                <div className="flex-1 min-w-0">
                  <div className="text-slate-800 leading-snug truncate">{p.descripcion}</div>
                  <div className="text-xs text-slate-400 mt-0.5">
                    {Number(p.cantidad)} {p.unidad} × {fmtEUR(p.precio_unitario)}
                  </div>
                </div>
                <div className="font-semibold text-slate-700 text-right whitespace-nowrap">
                  {fmtEUR(subtotal)}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mt-6 pt-4 border-t border-slate-200 ml-auto max-w-xs space-y-1.5 text-sm">
        <div className="flex justify-between">
          <span className="text-slate-500">Base imponible</span>
          <span>{fmtEUR(t.base)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-500">IVA (21%)</span>
          <span>{fmtEUR(t.iva)}</span>
        </div>
        <div className="flex justify-between pt-2 border-t border-slate-200">
          <span className="font-display font-bold">TOTAL</span>
          <span className="font-display font-bold text-blue-600 text-lg">{fmtEUR(t.total)}</span>
        </div>
      </div>
    </div>
  );
}
